export const ErrorIcon = () => (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.66895 3.64551C8.2291 2.56816 9.7709 2.56816 10.3311 3.64551L14.832 12.3086C15.3508 13.3071 14.6262 14.5 13.501 14.5H4.49902C3.37377 14.5 2.64924 13.3071 3.16797 12.3086L7.66895 3.64551Z"
            fill="white"
            stroke="white"
        />
        <path d="M8.83203 10.1525V6" stroke="#DF1313" strokeWidth="1.3" strokeLinecap="round" />
        <circle cx="8.82937" cy="12.4881" r="0.778589" fill="#DF1313" />
    </svg>
)
